import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { Apollo } from 'apollo-angular';
import { LicensedDesignProfessionalApiService } from '../licensed-design-professional-api.service';
import { IContact, IContactInput } from '../../../models/contact.interface';
import { ContactExistsDetailsQuery, GetContactByIdQuery, ListContactsQuery, contactLdpExistsDetail } from '../../../graphql/queries/contact.query';
import { CheckLdpLicense, ListLdpZipQuery, ListLdpFilterQuery } from '../../../graphql/queries/ldp.query';
import { CONTACT_LDP_MUTATION } from '../../../graphql/mutations/contact.mutation';
import { IEngineer } from '../../../models/engineer.interface';
import { IContactExists } from '@ebb-v2/ebb-integration';

@Injectable({
  providedIn: 'root'
})
export class LicensedDesignProfessionalGqlService implements LicensedDesignProfessionalApiService {
  currentUser: Observable<IContact>;

  constructor(private apollo: Apollo) {}

  public getLdpListZip(zip: string): Observable<IEngineer[]> {
    //console.log(`LDPGql.getLdpListZip(${zip})`);
    return this.apollo
      .watchQuery({
        query: ListLdpZipQuery,
        variables: {
          zip: zip,
        }
      })
      .valueChanges
      .pipe(map(result => result.data['contactLicensedDesignProfessionalProximityZIP'] as IEngineer[]), take(1));
  }

  public getLdpListFilter(filterString: string): Observable<IEngineer[]> {
    //console.log(`LDPGql.getLdpListFilter(${filterString})`);
    return this.apollo
      .watchQuery({
        query: ListLdpFilterQuery,
        variables: {
          filter: filterString,
        }
      })
      .valueChanges
      .pipe(map(result => result.data['contactLicensedDesignProfessionalFilter'] as IEngineer[]), take(1));
  }

  public getContact(id: string): Observable<IContact> {
    //console.log(`LDPGql.getContact()`);
    return this.apollo
      .watchQuery({
        query: GetContactByIdQuery,
        variables: {
          id: id
        }
      })
      .valueChanges.pipe(
        map(result => result.data['contact'] as IContact),
        take(1)
      );
  }

  public getContacts(): Observable<IContact[]> {
    console.log(`ContactGql.getContacts()`);
    return this.apollo
      .watchQuery({
        query: ListContactsQuery
      })
      .valueChanges.pipe(
        map(result => result.data['contacts'] as IContact[]),
        take(1)
      );
  }

  public checkLdpLicense(licenseNumber: string): Observable<IContact> {
    console.log(`ContactGql.checkLdpLicense()`);
    return this.apollo
      .watchQuery({
        query: CheckLdpLicense,
        variables: {
          licenseNumber: licenseNumber
        }
      })
      .valueChanges.pipe(
        map(result => result.data['checkLdpLicense'] as IContact),
        take(1)
      );
  }
  public CheckLdpContactExists(email: string) : Observable<IContactExists>{
    return this.apollo.query({
        query: contactLdpExistsDetail,
        fetchPolicy: 'network-only',
        variables: { email: email}
      })
      .pipe(map(result => {
        if(result.data['message']) {
          return result.data['message'];
        }
        return result.data['contactLdpExistsDetail'] as IContactExists;
      }
    ));
}
  public saveLdpContact(contact: IContactInput): any {
    console.log(`ContactGql.saveLdpContact()`);
    return this.apollo
      .mutate({
        mutation: CONTACT_LDP_MUTATION,
        variables: {
          contact
        }
      })
      .pipe(map(result => result.data['saveLdpContact'].id as string));
  }
}
